/*
  cart-bundle.js
  Progressive enhancement for the consolidated ritual-bundle card rendered by
  snippets/cart-bundle-card.liquid.

  - Toggles the nested "what's inside" list.
  - "Remove" clears every component line of the bundle in a single
    /cart/update.js call (keyed by variant id, so it is index-independent),
    then reuses Dawn's own cart pub/sub so the drawer, cart page and cart bubble
    re-render exactly as they do for any other cart change.

  This only reads/removes existing line items; it never changes how items are
  added to the cart. Uses event delegation so it keeps working after Dawn
  replaces the cart markup on re-render.
*/
(function () {
  function onClick(event) {
    var toggle = event.target.closest('[data-bundle-toggle]');
    if (toggle) {
      var card = toggle.closest('.cart-bundle-card');
      if (!card) return;
      var list = card.querySelector('[data-bundle-items]');
      if (!list) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (expanded) {
        list.setAttribute('hidden', '');
      } else {
        list.removeAttribute('hidden');
      }
      return;
    }

    var removeBtn = event.target.closest('[data-bundle-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeBundle(removeBtn);
    }
  }

  function removeBundle(btn) {
    // Prefer line KEYS: they target exactly the lines the card consumed, so a
    // duplicate standalone line of the same variant (rendered outside the
    // card) survives the removal. Variant ids remain as a fallback.
    var keysRaw = btn.getAttribute('data-line-keys') || '';
    var keys = keysRaw
      .split('|')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    var raw = btn.getAttribute('data-variant-ids') || '';
    var ids = raw
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    if (!keys.length && !ids.length) return;

    var card = btn.closest('.cart-bundle-card');
    if (card) card.classList.add('is-loading');

    var updates = {};
    if (keys.length) {
      keys.forEach(function (k) { updates[k] = 0; });
    } else {
      ids.forEach(function (id) { updates[id] = 0; });
    }

    fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        // If the removal emptied the cart, reload so the drawer's empty state
        // (rendered server-side) appears correctly.
        if (cart && cart.item_count === 0) {
          window.location.reload();
          return;
        }
        // Reuse Dawn's cart machinery to re-render everything.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-bundle' });
        } else {
          // Fallback: reload if the pub/sub helpers are unavailable.
          window.location.reload();
        }
      })
      .catch(function () {
        if (card) card.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', onClick);
})();
